import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=a7c2fdf8&scoped=true&"
import script from "./step6.vue?vue&type=script&lang=js&"
export * from "./step6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c2fdf8",
  null
  
)

export default component.exports